<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" v-has="'PlatAdmin,UnitAdmin'" @click="doAdd()">添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip v-has="'PlatAdmin,UnitAdmin'" effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin,UnitAdmin'" effect="dark" content="重置密码" placement="top">
                            <el-button size="small" icon="el-icon-magic-stick" @click="doPasswd()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin,UnitAdmin'" effect="dark" content="锁定" placement="top">
                            <el-button size="small" icon="el-icon-lock" @click="doLock()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin,UnitAdmin'" effect="dark" content="解除锁定" placement="top">
                            <el-button size="small" icon="el-icon-unlock" @click="doUnlock()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item v-has="'PlatAdmin'">
                            <el-select v-model="query.unid" placeholder="请选择归属单位" style="width:200px;" @change="doQuery" clearable>
                                <el-option v-for="unit in units" :key="unit.id" :label="unit.name" :value="unit.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="员工名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.key" clearable placeholder="员工账号" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column show-overflow-tooltip label="名称" width="200">
                    <template slot-scope="scope">
                        <el-tag type="danger" size="mini" style="margin-right: 10px;" v-if="scope.row.lock.flg">已锁定</el-tag>
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="账号" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.key }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="初始密码" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.dpwd }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="单位">
                    <template slot-scope="scope">
                        <span>{{ scope.row.unit.name || '平台' }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="角色">
                    <template slot-scope="scope">
                        <span>{{ scope.row.role | rname }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" v-has="'PlatAdmin,UnitAdmin'" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialog" width="500px">
            <el-form ref="form" :model="field" :rules="rules" label-width="80px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="field.name" placeholder="请填写员工名称"></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="key">
                    <el-input v-model="field.key" placeholder="请填写员工账号"></el-input>
                </el-form-item>
                <el-form-item label="归属单位" prop="unid" v-has="'PlatAdmin'">
                    <el-select v-model="field.unid" placeholder="请选择归属单位" style="width:100%;">
                        <el-option v-for="unit in units" :key="unit.id" :label="unit.name" :value="unit.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="角色" prop="role">
                    <el-select v-model="field.role" placeholder="请选择员工角色" style="width:100%;">
                        <el-option v-has="'PlatAdmin'" v-if="field.unid === 'Platform'" label="平台管理员" value="PlatAdmin"></el-option>
                        <el-option v-has="'PlatAdmin'" v-if="field.unid === 'Platform'" label="平台审核员" value="PlatAudit"></el-option>
                        <el-option v-has="'PlatAdmin'" v-if="field.unid === 'Platform'" label="平台查看员" value="PlatView"></el-option>
                        <el-option v-has="'PlatAdmin'" v-if="field.unid === 'Platform'" label="网站管理员" value="PlatCms"></el-option>
                        <el-option v-if="field.unid != 'Platform'" label="单位管理员" value="UnitAdmin"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="授权计划" prop="plan" v-if="field.role == 'PlatView' || field.role == 'PlatAudit'">
                    <el-select v-model="field.plans" multiple placeholder="请选择授权计划" style="width:100%;">
                        <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    unid: '',
    name: '',
    key: ''
}
const defaultField = {
    id: '',
    name: '',
    key: '',
    role: '',
    unid: '',
    plans: []
}
export default {
    name: 'SysEmp',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                ...defaultField
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写员工名称',
                        trigger: 'blur'
                    }
                ],
                key: [
                    {
                        required: true,
                        message: '请填写员工账号',
                        trigger: 'blur'
                    }
                ],
                unid: [
                    {
                        required: true,
                        message: '请选择归属单位',
                        trigger: 'blur'
                    }
                ],
                role: [
                    {
                        required: true,
                        message: '请选择员工角色',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false,
            units: [],
            plans: []
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['系统管理', '员工信息'])
        this.init()
    },
    filters: {
        rname: value => {
            switch (value) {
                case 'PlatAdmin':
                    return '平台管理员'
                case 'PlatView':
                    return '平台查看员'
                case 'PlatAudit':
                    return '平台审核员'
                case 'PlatCms':
                    return '网站管理员'
                case 'UnitAdmin':
                    return '单位管理员'
            }
        }
    },
    methods: {
        init() {
            if (this.$has('PlatAdmin')) {
                defaultField.unid = 'Platform'
                this.query.unid = 'Platform'
            } else {
                defaultField.unid = '1'
                this.query.unid = '1'
            }
            this.doLoad()
            this.doLoadUnit()
            this.doLoadPlan()
        },
        doLoadUnit() {
            this.$http
                .get('/comm/data/unit/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.units = result.datas
                    this.units.splice(0, 0, { id: 'Platform', name: '平台' })
                })
        },
        doLoadPlan() {
            this.$http
                .get('/comm/data/plan/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.plans = result.datas
                })
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/sys/emp/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.field = {
                ...item
            }
            this.field.unid = item.unit.id
            this.formDialog = true
        },
        doSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/sys/emp/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/sys/emp/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doPasswd(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要重置密码的账户')
                return
            }
            this.$confirm('是否重置账户[' + names.join() + ']的密码?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/comm/user/reset', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('重置成功，请使用初始密码登录')
                            this.doLoad()
                        }
                    })
            })
        },
        doLock(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要锁定登录的账户')
                return
            }
            this.$prompt('', '请输入锁定原因', {
                confirmButtonText: '锁定',
                cancelButtonText: '取消',
                inputValue: '账户违规，锁定登录',
                type: 'warning'
            })
                .then(({ value }) => {
                    this.$http
                        .post('/comm/user/lock', {
                            ids: ids.join(),
                            memo: value,
                            hour: 24 * 30 * 6
                        })
                        .then(result => {
                            if (result.code === 0) {
                                this.$message.success('锁定成功')
                                this.doLoad()
                            }
                        })
                })
                .catch(() => {})
        },
        doUnlock(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要解除锁定的账户')
                return
            }
            this.$confirm('是否解除账户[' + names.join() + ']的锁定状态?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/comm/user/unlock', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('解除锁定成功')
                            this.doLoad()
                        }
                    })
            })
        }
    }
}
</script>
